import { Alert, Button, TextField } from '@mui/material';
import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
    const [message, setMessage] = useState("");
    const formRef = useRef();

    const handleSubmit = e => {

        emailjs.sendForm(
            'service_eoo01dv',
            'template_c0ccbud',
            formRef.current,
            'user_FtTFVHVL5CzMI3Q19d0lI'
        )
            .then((result) => {
                console.log(result.text);
                setMessage('Your message succesfully sent😄');
            }, (error) => {
                console.log(error.text);
                setMessage('Provide Valid Information');
            });

        e.target.reset();
        e.preventDefault();
    }

    return (
        <div>
            <form ref={formRef} onSubmit={handleSubmit}>
                <TextField
                    sx={{ width: '100%', m: 1 }}
                    id="standard-basic"
                    placeholder="Name"
                    name="name"
                    variant="standard"
                    type="text"
                    required />
                <TextField
                    sx={{ width: '100%', m: 1 }}
                    id="standard-basic"
                    placeholder="Email"
                    variant="standard"
                    type="email"
                    name="email"
                    required />
                <TextField
                    sx={{ width: '100%', m: 1 }}
                    id="standard-multiline-static"
                    placeholder="Message"
                    variant="standard"
                    name="message"
                />
                <Button style={{ backgroundColor: 'gray', marginLeft: '8px' }} variant="contained" type="submit">Send</Button>
            </form>

            {message && <Alert sx={{ m: 1 }} severity="success"> {message} </Alert>}
            {/* {!message && <Alert sx={{ m: 1 }} severity="success"> {message} </Alert>} */}
        </div>
    );
};

export default Contact;